import React, { useMemo } from 'react';
import { Avatar, Divider } from '@zillow/constellation-10';
import { Flex, Paragraph } from '@zillow/constellation';
import { format } from 'date-fns';

import { CALENDAR_EVENT_DATE_DISPLAY_FORMAT_STRING, type TourEvent } from '../../../../constants/TourCalendar';
import { getTourEventTimeRange } from '../../../../utils/formatTime';
import TourEventPopoverBodyFooter from './components/TourEventPopoverBodyFooter';
import CancelTourConfirmationModal from './components/CancelTourConfirmationModal/CancelTourConfirmationModal';

type TourEventPreviewPopoverBodyProps = {
  event: TourEvent;
  onDeclineClick: () => void;
  onConfirmClick: () => void;
  onCancelTourConfirmationClick: () => void;
};

const TourEventPopoverBody = (props: TourEventPreviewPopoverBodyProps) => {
  const { event } = props;
  const [showCancelTourConfirmationModal, setShowCancelTourConfirmationModal] = React.useState(false);
  const timeRange = useMemo(() => getTourEventTimeRange(event), [event]);
  const shouldDisplayFooter = event.allowedLandlordActions.length > 0 && !event.isPastEvent;

  const handleCancelTourInitialClick = () => {
    setShowCancelTourConfirmationModal(true);
  };

  return (
    <div data-testid="TourEventPopoverBody">
      <Paragraph fontType="bodySmallHeading" data-testid="TourEventPopoverBody-Date">
        Date
      </Paragraph>
      <Paragraph marginY="sm">{format(new Date(event.start), CALENDAR_EVENT_DATE_DISPLAY_FORMAT_STRING)}</Paragraph>
      <Paragraph marginY="sm" fontType="bodySmallHeading" data-testid="TourEventPopoverBody-Time">
        Time
      </Paragraph>
      <Paragraph marginY="sm">{timeRange}</Paragraph>
      <React.Fragment>
        <Paragraph marginY="sm" fontType="bodySmallHeading" data-testid="TourEventPopoverBody-Renter">
          Renter
        </Paragraph>
        <Flex display="flex" alignItems="center" marginY="sm">
          <Avatar fullName={event.bookedByName} size="sm" />
          <Paragraph marginLeft="xs">{event.bookedByName}</Paragraph>
        </Flex>
      </React.Fragment>
      {shouldDisplayFooter && (
        <>
          <Divider css={{ marginTop: 'default', marginBottom: 'default' }} />
          <TourEventPopoverBodyFooter onCancelTourInitialClick={handleCancelTourInitialClick} {...props} />
        </>
      )}
      {showCancelTourConfirmationModal && (
        <CancelTourConfirmationModal
          event={event}
          onClose={() => setShowCancelTourConfirmationModal(false)}
          onCancelTourConfirmationClick={props.onCancelTourConfirmationClick}
        />
      )}
    </div>
  );
};

export default TourEventPopoverBody;
